import React, { FC, ReactElement, useState } from 'react';
import { Mutation } from '@apollo/client/react/components';
import { SubmitHandler } from 'react-hook-form';

import { specialPublicationUrl } from 'buyside/util/urlHelper';

import SpecialPublicationPreAccessForm from './SpecialPublicationPreAccessForm';
import { CaptureSpecialPublicationUserEmailInput } from 'interfaces/graphql-typings';

import {
  CaptureSpecialPublicationUserEmailMutation,
  CaptureSpecialPublicationUserEmailMutationVariables
} from 'interfaces/graphql-typings';

import ReCAPTCHAMutationContainer, {
  ReCAPTCHAMutationChildrenProps
} from 'buyside/components/container/MutationContainers/ReCAPTCHA/ReCAPTCHAMutationContainer';

const mutation = require('buyside/graphql/mutations/CaptureSpecialPublicationUserEmail.graphql');

const SpecialPublicationPreAccessFormContainer: FC<{
  specialPublicationId: string;
  vanityName: string;
}> = ({ specialPublicationId, vanityName }): ReactElement => {
  const [hasError, setError] = useState(false);

  return (
    <ReCAPTCHAMutationContainer
      pageName="special publication pre access form"
      action="CaptureSpecialPublicationUserEmail"
    >
      {({ grecaptcha }: ReCAPTCHAMutationChildrenProps): ReactElement => (
        <Mutation<
          CaptureSpecialPublicationUserEmailMutation,
          CaptureSpecialPublicationUserEmailMutationVariables
        >
          mutation={mutation}
        >
          {(captureUserDetails): ReactElement => {
            const onSubmit: SubmitHandler<CaptureSpecialPublicationUserEmailInput> = async (
              data
            ): Promise<void> => {
              await grecaptcha().then(
                async (): Promise<void> => {
                  setError(false);
                  await captureUserDetails({
                    variables: { ...data, specialPublicationId }
                  }).then(
                    (): void => {
                      window.location.href = specialPublicationUrl(vanityName);
                    },
                    (): void => {
                      setError(true);
                    }
                  );
                }
              );
            };
            return (
              <SpecialPublicationPreAccessForm
                onSubmit={onSubmit}
                grecaptcha={grecaptcha}
                submissionError={hasError}
              />
            );
          }}
        </Mutation>
      )}
    </ReCAPTCHAMutationContainer>
  );
};

export default SpecialPublicationPreAccessFormContainer;
